import { render, staticRenderFns } from "./TheMenuItem.vue?vue&type=template&id=59f103e0&scoped=true"
import script from "./TheMenuItem.vue?vue&type=script&lang=js"
export * from "./TheMenuItem.vue?vue&type=script&lang=js"
import style0 from "./TheMenuItem.vue?vue&type=style&index=0&id=59f103e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f103e0",
  null
  
)

export default component.exports